// Centralized API base URL configuration.
// For local development (running on localhost / 127.x / 192.168.x / *.local),
// we always point to the staging services, regardless of what is in the branch-specific .env.
// For staging deployments, we also use staging URLs.
// For production deployments, we use the environment variables from .env.

const STAGING_ERP_BASE_URL = "https://stag-micro.bcykal.com/mobycy";
const STAGING_MEDIA_BASE_URL = "https://stag.bcykal.com/mobycy/api/media/file";
// const STAGING_ERP_BASE_URL_AUTHENTICATION = "https://msapi.bcykal.com/mobycy";
const STAGING_ERP_BASE_URL_DATA_SCIENCE_REPORTS =
  "https://data.bcykal.com/tracker-stag/";

const isLocalHost = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const hostname = window.location.hostname;

  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("192.168.") ||
    hostname.endsWith(".local")
  );
};

const isStagingEnvironment = (): boolean => {
  // Check if we're on localhost (always use staging for local dev)
  if (isLocalHost()) {
    return true;
  }

  // Check if hostname contains staging indicators
  if (typeof window !== "undefined" && window.location) {
    const hostname = window.location.hostname.toLowerCase();
    if (
      hostname.includes("stag") ||
      hostname.includes("staging") ||
      hostname.includes("test") ||
      hostname.includes("dev")
    ) {
      return true;
    }
  }

  // Check if environment variable URL contains staging indicators
  const envUrl = process.env.REACT_APP_ERP_BASE_URL || "";
  if (envUrl.toLowerCase().includes("stag") || envUrl.toLowerCase().includes("staging")) {
    return true;
  }

  return false;
};

// Get the appropriate base URL
const getBaseUrl = (
  stagingUrl: string,
  envVar?: string
): string => {
  if (isStagingEnvironment()) {
    // Always use staging for localhost or staging deployments
    return stagingUrl;
  }
  // For production, use the environment variable
  return envVar || stagingUrl;
};

export const ERP_BASE_URL = getBaseUrl(
  STAGING_ERP_BASE_URL,
  process.env.REACT_APP_ERP_BASE_URL
);

export const ERP_BASE_URL_AUTHENTICATION = getBaseUrl(
  STAGING_ERP_BASE_URL,
  process.env.REACT_APP_ERP_BASE_URL_AUTHENTICATION
);

export const ERP_BASE_URL_DATA_SCIENCE_REPORTS = getBaseUrl(
  STAGING_ERP_BASE_URL_DATA_SCIENCE_REPORTS,
  process.env.REACT_APP_ERP_BASE_URL_DATA_SCIENCE_REPORTS || "https://data.bcykal.com"
);

export const MEDIA_BASE_URL = getBaseUrl(
  STAGING_MEDIA_BASE_URL,
  process.env.REACT_APP_MEDIA_BASE_URL || "https://dash.bcykal.com/mobycy/api/media/file"
);
